<template lang="pug">
v-main
  v-container
    v-dialog(v-model='dialogUniqueFullname' max-width='400')
        v-card
          v-card-title.text-h5
            p(style="margin:auto") Confirm
          v-card-text(style="margin-bottom:0.5rem")
            p(style="margin:auto; font-size:18px; text-align:center") User with current name is already Exist, Are you sure want to continue ?
          v-card-actions()
            v-spacer
            div(style="display:flex; width:100%")
              v-btn(style="color:#000; flex:1;margin:.3rem" text='' @click='dialogUniqueFullname = false')
                | No
              v-btn(style="background:#1976D2;color:#fff; flex:1;margin:.3rem" text='' @click='create(); dialogUniqueFullname = false')
                | Yes
    v-card
      v-toolbar.elevation-0(color="white")
        v-toolbar-title Create Account
      v-divider
      v-toolbar.elevation-0.mt-4.mb-4(color="white")
        //- v-text-field(
        //-     flat append-icon='search' 
        //-     placeholder='Search existing user from another BU (by email or name)' 
        //-     type="email"
        //-     v-model='keyword' 
        //-     class='hidden-sm-and-down col-12'
        //-     @keyup="search()"
        //-     :rules="[rules.minLength]"
        //-     ref="validation_check"
        //- )

        v-autocomplete(
          v-model="select",
          :items="items",
          :loading="isLoading",
          :search-input.sync="search",
          clearable="",
          hide-no-data="",
          item-text="full_name_email",
          item-value="item",
          chips,
          item-data="item",
          return-object,
          hint="Enter at least 3 letters to find out the search results.",
          label="Search existing user from another BU (by email or name)",
          @click:clear="clearData()",
          @keyup.delete="clearData()"
        )
          template(v-slot:selection="{ attr, on, item, selected }")
            v-chip.white--text(
              v-bind="attr",
              :input-value="selected",
              color="blue-grey",
              v-on="on"
            ) {{ item.full_name }}

          template(v-slot:item='{ item }')
            v-list-item-content()
            v-list-item(@click="clickList(item)") {{item.full_name}} - {{item.email}}

      v-divider.mt-4
      v-card-text
        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(color="black") 
              span(style="color: #D42A2A;") *
              | &nbsp;Name&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="users.full_name",
              label="Name",
              :rules="[rules.required]",
              :disabled="isSearch",
              @keyup="sendVal(users)",
              @keypress="isLetter($event)"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              span(style="color: #D42A2A;") *
              | &nbsp;Email&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
            small(style="color: #F08703;" class="ml-4") *Email account credential login
          v-col(cols="5")
            v-text-field(
              v-model='users.email' 
              label="Email (Don't use personal e-mail)"
              type="email" 
              :rules="[rules.required, rules.email]"
              :disabled="isSearch"
              @keyup="sendVal(users)"
            )

        //- v-row(no-gutters)
        //-   v-col(cols="4") 
        //-     v-subheader Phone Number
        //-   v-col(cols="5")
        //-     v-text-field(
        //-       maxlength="14",
        //-       v-model="users.msisdn",
        //-       label="Phone Number",
        //-       :rules="[rules.required, rules.number, rules.msisdn]",
        //-       :disabled="isSearch",
        //-       @keyup="sendVal(users)",
        //-       @keypress="isNumber($event)"
        //-     )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(color="black")
              span(style="color: #D42A2A;") *
              | &nbsp;Alias Name&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.alias",
              label="Alias",
              :rules="[rules.required]",
              @keypress="isLetter($event)"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              span(style="color: #D42A2A;") *
              | &nbsp;Business Unit Email&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
            small(style="color: #F08703;" class="ml-4") *Email for notification memo 
          v-col(cols="5")
            v-text-field(
              v-model='bu.email' 
              label="Email (Don't use personal e-mail)"
              type="email" 
              :rules="[rules.required, rules.email]"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader(style="height: 16px;") 
              | &nbsp;Business Unit Phone Number&nbsp;
              span(style="font-size:.7rem; color: #909090") (Optional)
            small(style="color: #F08703;" class="ml-4") *Phone number for notification memo
          v-col(cols="5")
            vue-tel-input(
              @validate="telValidate" 
              v-model="bu.msisdn"
              style="border-top: none; box-shadow: none; border-right: none; border-left: none; border-bottom: 2px solid;"
            )
            p(style="color: #ff5252; margin: 0; font-size: 12px;" v-if="bu.msisdn.length > 0 && !validNumber") invalid Phone Number Format

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Position&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-text-field(
              v-model="bu.position",
              label="Position",
              :rules="[rules.required]"
            )

        v-row(no-gutters)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Business Unit&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-autocomplete(
              v-if="$store.state.dataUsers.role == 'super_user'",
              ref="bu.bisnis_unit",
              v-model="bu.bisnis_unit",
              :rules="[() => !!bu.bisnis_unit || 'This field is required.']",
              :items="bisnis_units",
              item-text="name",
              item-value="_id",
              label="Business Unit",
              placeholder="Select",
              required
            )

            v-autocomplete(
              v-else-if="$store.state.dataUsers.role == 'admin'",
              ref="bisnis_unit",
              v-model="bu.bisnis_unit",
              :rules="[() => !!bu.bisnis_unit || 'This field is required.']",
              :items="bisnis_units",
              item-text="business_unit.bu_name",
              item-value="business_unit.id",
              label="Business Unit",
              placeholder="Select",
              required
            )
        v-row(no-gutters v-if="$store.state.dataUsers.role != 'super_user'",)
          v-col(cols="4") 
            v-subheader 
              span(style="color: #D42A2A;") *
              | &nbsp;Group&nbsp;
              span(style="font-size:.7rem; color: #909090") (Required)
          v-col(cols="5")
            v-radio-group(v-model="role", row)
              v-radio(label="Admin" value="admin")
              v-radio(label="User" value="user")

        //- Container dengan background merah untuk Payment Voucher Access dan Auto Notif Payment Request
        v-row(no-gutters)
          v-col(cols="9")
            v-card(
              class="pa-4 mb-4 pt-1"
              style="border: 1px solid #ef5350;"
            )
              //- Title di atas Payment Voucher Access
              v-col(class="d-flex align-center" style="margin-left: -10px; position: relative;")
                v-subheader(
                  style="color: #000; font-weight: 600; font-size: 16px; height: auto; padding-left: 0;"
                ) Payment Voucher Activation
                v-icon(
                  small
                  color="blue"
                  style="cursor: pointer; margin-left: -12px;"
                  @mouseenter="showTooltipHeader = true"
                  @mouseleave="showTooltipHeader = false"
                ) mdi-information
                .custom-tooltip-header(v-if="showTooltipHeader") 
                  | This process follows the Payment Request and is performed by the Finance Team.

              v-row(no-gutters style="margin-left: -15px;" align="center" class="mb-7")
                v-col(cols="4" class="d-flex align-center") 
                  v-subheader(style="height: auto; padding-top: 0; padding-bottom: 0;") Payment Voucher Access
                v-col(cols="6" class="d-flex align-center")
                  v-checkbox(
                    v-model="bu.is_payment_voucher"
                    label="Yes"
                    hide-details
                    class="mt-0 pt-0"
                  )

              v-row(
                no-gutters 
                align="center"
                style="margin-left: -15px;"
              )
                v-col(cols="4" class="d-flex align-center" style="position: relative;")
                  v-subheader(style="height: auto; padding-top: 0; padding-bottom: 0;") Auto Notif Payment Request
                  v-icon(
                    small
                    color="blue"
                    style="cursor: pointer; margin-left: -12px;"
                    @mouseenter="showTooltip = true"
                    @mouseleave="showTooltip = false"
                  ) mdi-information
                  .custom-tooltip(v-if="showTooltip") 
                    | When the flag is ‘Yes’, the system automatically sends an email to the user upon full approval of a Payment Request.
                v-col(cols="6" class="d-flex align-center")
                  v-checkbox(
                    v-model="bu.is_auto_notif_pr"
                    label="Yes"
                    :disabled="!bu.is_payment_voucher"
                    hide-details
                    class="mt-0 pt-0"
                  )

        v-card-actions.my-8
          v-btn.custom__padding-btn(
            v-if="$store.state.dataUsers.role == 'super_user'",
            @click="$router.push('/users-general')"
          ) Back
          v-btn.custom__padding-btn(
            v-else-if="$store.state.dataUsers.role == 'admin'",
            @click="$router.push('/users')"
          ) Back

          v-btn.custom__padding-btn(
            v-if="!user_id",
            :disabled="!formIsValid",
            color="blue-secondary",
            @click="confirmCreate()"
          ) Create

          v-btn.custom__padding-btn(
            v-if="user_id",
            :disabled="!formIsValid",
            color="blue-secondary",
            @click="createBU()"
          ) Create

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  data: () => ({
    dialogUniqueFullname: false,
    loading: false,
    isLoading: false,
    search: null,
    select: null,
    validNumber:  false,
    showTooltip: false,
    showTooltipHeader: false,
    users: {
      full_name: "",
      email: "",
      msisdn: "",
    },
    bu: {
      alias: "",
      email: "",
      msisdn: "",
      position: "",
      bisnis_unit: "",
      is_active: true,
      is_admin: false,
      is_payment_voucher: false,
      is_auto_notif_pr: false,
    },
    role: "admin",
    user_id: "",
    items: [],
    bisnis_units: [],
    keyword: "",
    rules: {
      required: (value) => !!value || "This field is required.",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid email format";
      },
      number: (v) => /^\d+$/.test(v) || "Must start 08 or 62",
      msisdn: (value) =>
        (value && value.length >= 10) || "Mobile number cannot be less than 10",
      minLength: (value) =>
        (value && value.length >= 3) || "String cannot be less than 3",
    },
    overlay: false,
    isSearch: false,
  }),
  computed: {
    ...mapState(["dataUsers", "loadingData", "showDrawer"]),
    formIsValid() {
      return (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.users.email
        ) &&
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.bu.email
        ) &&
        this.users.full_name &&
        this.users.email &&
        //- this.users.msisdn.length >= 10 &&
        this.bu.alias &&
        this.bu.email &&
        (this.validNumber || this.bu.msisdn.length == 0) &&
        this.bu.position && 
        this.bu.bisnis_unit
      );
    },
  },
  mounted() {
    // this.$store.dispatch("getBisnisUnit")
    this.getBisnisUnit();
  },
  watch: {
    'bu.is_payment_voucher'(newVal) {
      if (!newVal) {
        this.bu.is_auto_notif_pr = false;
      }
    },
    search(val) {
      //- const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //- let param = ''
      //-     if(pattern.test(val)){
      //-         param = `?email=${val}`
      //-     }else{
      //-         param = `?name=${val}`
      //-     }

      // Items have already been loaded
      //- if (this.items.length > 0) return

      // Lazily load input items
      if (val.length >= 3 && val.trim().length) {
        this.isLoading = true;
        let token = localStorage.getItem("token");
        axios
          .get(process.env.VUE_APP_API + `/users/find?key=${val.trim()}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            for ( let i in res.data.data) res.data.data[i].full_name_email = `${res.data.data[i].full_name}-${res.data.data[i].email}`
            return this.items = res.data.data;
          })
          .catch((err) => {
            if (err.response.status == 401 || err.response.status == 403) {
              this.$store.dispatch("logout");
              return this.$router.push("/");
            }
          })
          .finally(() => (this.isLoading = false));
      }
      if (val.length < 3) {
        this.isLoading = false;
      }
    },
  },
  methods: {
    telValidate(telnumber) {
      if (telnumber.valid || this.bu.msisdn.length == 0) this.validNumber = true
      else  this.validNumber = false
    },
    clearData() {
      this.items = [];
      this.item = [];
      this.users.full_name = "";
      this.users.email = "";
      this.user_id = "";
      this.isSearch = false;
    },
    async confirmCreate() {
      let token = localStorage.getItem('token');
      const isFullnameUnique = await axios.get(process.env.VUE_APP_API+`/users/findByFullname?fullname=${this.users.full_name}`, {
        headers: { 
          Authorization: `Bearer ${token}`
        }
      })
      if (isFullnameUnique.data.data == null) return this.create()
      else this.dialogUniqueFullname = true
    },
    create() {
      this.overlay = true;
      this.users.msisdn = this.bu.msisdn;
      this.role == "admin" && this.$store.state.dataUsers.role != "super_user" ? this.bu.is_admin = true : null
      this.$store
        .dispatch("createDataUsersBU", { users: this.users, bu: this.bu })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          this.$toasted.success("Success, account added successfully", {
            icon: "check_circle",
          });

          if (this.$store.state.dataUsers.role == "super_user") {
            return this.$router.push("/users-general");
          } else {
            return this.$router.push("/users");
          }
        })
        .catch((err) => {
          this.overlay = false;
          if (typeof err == 'string') this.$toasted.error(err, { icon: "error" });
          else this.$toasted.error(err.response.data.message, { icon: "error" });
        });
    },
    createBU() {
      this.overlay = true;
      this.role == "admin" && this.$store.state.dataUsers.role != "super_user" ? this.bu.is_admin = true : null
      this.$store
        .dispatch("addBisnisUnitToUsers", {
          bu: this.bu,
          user_id: this.user_id,
        })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          this.$toasted.success("Success, account added successfully", {
            icon: "check_circle",
          });

          if (this.$store.state.dataUsers.role == "super_user") {
            return this.$router.push("/users-general");
          } else {
            return this.$router.push("/users");
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.message, { icon: "error" });
        });
    },

    getBisnisUnit() {
      if (this.$store.state.dataUsers.role == "super_user") {
        let token = localStorage.getItem("token");
        axios
          .get(process.env.VUE_APP_API + `/business-unit/list/active`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.bisnis_units = res.data.data;
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => (this.loading = false));
      } else {
        if (this.$store.state.dataUsers.user) {
          this.bisnis_units = this.$store.state.dataUsers.user.bu.filter(
            (bu) => bu.is_admin === true && bu.is_active === true
          );
        } else {
          this.bisnis_units = this.$store.state.dataUsers.bu.filter(
            (bu) => bu.is_admin === true && bu.is_active === true
          );
        }
      }
    },
    //- searchadata(val) {

    //-     // this.overlay = true;
    //-     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //-     if (this.$refs.validation_check.validate() == false) {
    //-         this.overlay = false;
    //-         // this.$toasted.error("Invalid format email", {icon: 'error'});

    //-     } else {
    //-         let param = ''
    //-         if(pattern.test(this.keyword)){
    //-             param = `?email=${this.keyword}`
    //-         }else{
    //-             param = `?name=${this.keyword}`
    //-         }
    //-         let token = localStorage.getItem('token');
    //-         axios.get(process.env.VUE_APP_API+`/users/find`+param,
    //-         {
    //-             headers: { Authorization: `Bearer ${token}` }
    //-         })
    //-         .then(res => {

    //-             this.overlay = false;
    //-             if(res.data.data.length == 0) {
    //-                 this.items = []
    //-                 this.users.full_name = ''
    //-                 this.users.email = ''
    //-                 this.users.msisdn = ''
    //-                 this.user_id = ''
    //-                 // this.$toasted.error("Email not found");
    //-             } else {
    //-                 this.items = res.data.data
    //-                 // res.data.data.forEach(result => {

    //-                 //     this.users.full_name = result.full_name
    //-                 //     this.users.email = result.email
    //-                 //     this.users.msisdn = result.msisdn
    //-                 //     this.user_id = result._id
    //-                 //     this.isSearch = true
    //-                 // })
    //-             }
    //-         })
    //-         .catch(err => {
    //-             this.overlay = false;
    //-             this.$toasted.error(err, { icon : 'error'})
    //-         })
    //-     }
    //- },
    sendVal(item) {
      this.bu.alias = item.full_name;
      this.bu.email = item.email;
      //- this.bu.msisdn = item.msisdn;
    },
    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9 ]+$/.test(char)) return true;
      else e.preventDefault();
    },
    clickList(item) {
      this.users.full_name = item.full_name;
      this.users.email = item.email;
      //- this.users.msisdn = item.msisdn;this
      this.user_id = item._id;
      this.isSearch = true;
      this.select = ""
    },
  },
};
</script>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}

.custom-tooltip-header {
  position: absolute;
  bottom: 75%;
  left: 50%;
  transform: translateX(-94%);
  margin-bottom: 12px;
  background-color: #616161;
  color: white;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 14px;
  white-space: normal;
  max-width: 400px;
  width: max-content;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.custom-tooltip-header::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #616161;
}

.custom-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-33%);
  margin-bottom: 12px;
  background-color: #616161;
  color: white;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 14px;
  white-space: normal;
  max-width: 400px;
  width: max-content;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.custom-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #616161;
}
</style>
